/* eslint-disable */
import React from "react";
import RenderCalendlyLinks from "../../components/common/RenderCalendlyLinks";
import NewProductTemplate from "../../components/sections/product-more-info/Item";
import { cn } from "../../utils/cn";
import Emoji from "../../utils/emoji";
import ProductTemplate from "./product";

const Product = (props) => {
    const { pageContext } = props;
    const { item } = pageContext;

    const newProductsEnabled =
        process.env.GATSBY_NEW_PRODUCTS_ENABLED === "true";

    const Data = () => {
        return (
            <section className="mx-auto max-w-xl text-left font-inter text-gray-500 lg:max-w-2xl xl:max-w-3xl">
                <h2 className={cn(styles.title)}>
                    <Emoji symbol="🎤" label="entrevista" /> FASE 2: Preparació
                    Entrevista Policial Mossos d&apos;Esquadra Convocatòria
                    46/25 (maig 2025)
                </h2>

                <p className="mt-5">
                    La fase d&apos;entrevista és una de les proves més decisives
                    del procés selectiu de{" "}
                    <strong className="text-cpurple">
                        Mossos d&apos;Esquadra
                    </strong>
                    . No n&apos;hi ha prou amb haver superat les proves
                    anteriors: cal{" "}
                    <strong className="text-cpurple">
                        defensar correctament el teu perfil
                    </strong>
                    , comunicar amb seguretat i{" "}
                    <strong className="text-cpurple">
                        demostrar que encaixes amb el model professional
                    </strong>{" "}
                    que avalua el tribunal.
                </p>

                <p>
                    Aquest curs està dissenyat{" "}
                    <strong className="text-cpurple">
                        exclusivament per a opositors que es presenten a
                        l&apos;entrevista policial de Mossos d&apos;Esquadra
                    </strong>
                    , amb una preparació{" "}
                    <strong className="text-cpurple">
                        realista, personalitzada i alineada amb els criteris
                        oficials
                    </strong>
                    .
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🎯" label="objectiu" /> Què és aquest curs?
                </h2>

                <p className="mt-5">
                    És una{" "}
                    <strong className="text-cpurple">
                        formació específica
                    </strong>{" "}
                    per preparar la fase d&apos;entrevista personal de Mossos
                    d&apos;Esquadra. Treballarem{" "}
                    <strong className="text-cpurple">
                        com funciona realment l&apos;entrevista
                    </strong>
                    , què s&apos;avalua i com estructurar les teves respostes
                    perquè siguin coherents, sòlides i creïbles.
                </p>

                <p>
                    El <strong className="text-cpurple">Fase 2</strong> és una{" "}
                    <strong className="text-cpurple">
                        sessió individual i presencial
                    </strong>
                    , pensada per preparar amb detall la teva{" "}
                    <strong className="text-cpurple">
                        primera entrevista policial
                    </strong>{" "}
                    de Mossos d&apos;Esquadra.
                </p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong>Durada:</strong> 1 hora i 30 minuts
                    </li>
                    <li>
                        <strong>Format:</strong> presencial i individual
                    </li>
                </ul>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🔍" label="analisi" /> Com treballem la Fase
                    2?
                </h2>

                <p className="mt-5">
                    A iOpos no treballem amb{" "}
                    <strong className="text-cpurple">
                        respostes estàndard
                    </strong>
                    . Cada opositor és{" "}
                    <strong className="text-cpurple">
                        analitzat de manera individual
                    </strong>
                    , adaptant l&apos;entrevista al seu perfil real.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="👤" label="perfil" /> A qui va dirigit?
                </h2>

                <p className="mt-5">
                    Aquest curs és{" "}
                    <strong className="text-cpurple">per a tu</strong> si:
                </p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        Et presentes a l&apos;entrevista de Mossos
                        d&apos;Esquadra.
                    </li>
                    <li>Vols arribar-hi amb més seguretat i criteri.</li>
                    <li>Necessites practicar en un entorn real i controlat.</li>
                    <li>
                        Vols evitar errors que poden suposar un{" "}
                        <strong>NO APTE</strong>.
                    </li>
                </ul>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🔥" label="resum" /> En resum
                </h2>

                <p className="mt-5">
                    Una preparació{" "}
                    <strong className="text-cpurple">
                        clara, pràctica i personalitzada
                    </strong>{" "}
                    per afrontar amb garanties l&apos;entrevista a Mossos
                    d&apos;Esquadra, entenent{" "}
                    <strong className="text-cpurple">què s&apos;avalua</strong>{" "}
                    i{" "}
                    <strong className="text-cpurple">
                        com defensar el teu perfil
                    </strong>{" "}
                    de manera sòlida.
                </p>

                <h2 className={cn(styles.title, "mt-10")} id="reserva">
                    <Emoji symbol="📅" label="reserva" /> Reserva la teva hora!
                </h2>

                <p className="mt-5">
                    Disposem de{" "}
                    <strong className="text-cpurple">
                        diversos professors tutors especialitzats
                    </strong>{" "}
                    en l’entrevista policial, que seran els encarregats de
                    realitzar les sessions de preparació. A continuació pots
                    consultar els{" "}
                    <strong className="text-cpurple">
                        calendaris disponibles
                    </strong>{" "}
                    i <strong className="text-cpurple">reservar l’hora</strong>{" "}
                    amb el tutor que millor s’adapti a la teva disponibilitat.
                </p>

                <RenderCalendlyLinks
                    stock={item.stock}
                    calendly_schedule={item.calendly_schedule}
                />
            </section>
        );
    };

    return (
        <>
            {!newProductsEnabled ? (
                <ProductTemplate item={item}>
                    <Data />
                </ProductTemplate>
            ) : (
                <NewProductTemplate
                    item={item}
                    title="Sessió personalitzada per defensar el teu perfil amb seguretat i criteri a l’entrevista de Mossos d’Esquadra."
                >
                    <Data />
                </NewProductTemplate>
            )}
        </>
    );
};

const styles = {
    strong: "font-semibold text-ccyan",
    title: "font-bold text-xl font-montserrat",
    list: "list-disc ml-4",
};

export default Product;
